import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Serializer from './serializer';
import DEFAULT_FILTER from './defaultFilter';
/**
 * @param {import('./types').DataFilterDefaultValueType} defaultValue
 * @param {import('./types').DataFilterValueType} baseValue
 */

var getDefaultFilterValue = function getDefaultFilterValue(defaultValue, baseValue) {
  if (!baseValue) baseValue = DEFAULT_FILTER;else if (typeof baseValue === 'object') baseValue = _objectSpread({}, DEFAULT_FILTER, baseValue);
  if (!defaultValue) return baseValue;
  if (typeof defaultValue === 'string') return Serializer.deserialize(defaultValue, baseValue);
  return _objectSpread({}, baseValue, defaultValue);
};
/**
 * @param {import('./types').DataFilterDefaultValueType} defaultValue
 * @param {import('./types').DataFilterValueType} [baseValue] Used as base filter when providing partial `value`. The value to reset to when clearing filters.
 * @returns {[ import('./types').DataFilterValueType, import('./types').DataFilterOnChangeCallback ]}
 */


var useFilter = function useFilter(defaultValue) {
  var baseValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var defaultFilter = getDefaultFilterValue(defaultValue, baseValue);

  var _React$useState = React.useState(defaultFilter),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filter = _React$useState2[0],
      setFilter = _React$useState2[1];

  var onChange = {
    search: function search(_ref) {
      var filter = _ref.filter,
          value = _ref.value;
      setFilter(function (prevState) {
        var newState = _objectSpread({}, prevState, {
          searchIn: filter || defaultFilter.searchIn,
          searchValue: value
        });

        return newState;
      });
    },
    filter: function filter(e, _ref2) {
      var label = _ref2.label,
          value = _ref2.value;

      if (!value) {
        setFilter(defaultFilter);
        return;
      }

      setFilter(function (prevState) {
        return _objectSpread({}, prevState, {
          label: label,
          filterBy: value.filterBy,
          filterValue: value.filterValue
        });
      });
    }
  };
  return [filter, onChange];
};

export default useFilter;